import { useEffect, useMemo, useRef, useState,useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios'
import AuthContext from '../../AuthContext'
import { useNavigate } from 'react-router-dom';
import { Menu ,Paper} from '@mantine/core';

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const [year, month, day] = new Date(dateString).toLocaleDateString('en-CA', options).split('-');
  return `${day}-${month}-${year}`;
};

const Example = ({ updateProductModalSetting ,handlePageUpdate}) => {
  const {centre}=useContext(AuthContext)
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        accessorKey: 'trainer_code',
        header: 'Trainer Code',
        size: 170,
      },
      {
        accessorKey: 'full_name',
        header: 'Trainer Name',
        size: 170,
      },
      {
        accessorKey: 'address',
        header: 'Address',
        size: 150,
      },
      {
        accessorKey:'email',
        header:'Email',
        size:150
      },
      {
        accessorKey: 'mob_no',
        header: 'Phone No',
        size: 150,
      },
      {
        accessorKey: 'pan_no',
        header: 'Pan No.',
        size: 150,
    
      },
      {
        accessorKey:'aadhar_no',
        header:'Aadhar No,'
      },
      {
        accessorKey: 'district',
        header: 'District',
        size: 150,
      },
      {
        accessorKey: 'experience',
        header: 'Experience',
        size: 150,
      },
      {
        accessorKey: 'qualification',
        header: 'Qualification',
        size: 150,
      },
      {
        accessorKey: 'gender',
        header: 'Gender',
        size: 150,
      },
      {
        accessorKey: 'marital_status',
        header: 'Marital Status',
        size: 150,
      },
      {
        accessorKey: 'dob',
        header: 'DOB',
        size: 150,
        cell: ({ value }) => formatDate(value), // Format date in the cell
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 150,
      },
      {
        accessorKey:'sector_names',
        header: 'Sector',
      },
      {
        accessorKey: 'course_names',
        header: 'Course',
      }
    ],
    [],
  );
  
  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  useEffect(() => {
    axios.post('/trainer/getAll',{
      
        centre_id:centre
      
    })
      .then((res) => {
        const formattedData = res.data.map((item) => ({
          ...item,
          dob: formatDate(item.dob) // Format the 'dob' field
        }));
        setData(formattedData);
        
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate,centre]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
        <Menu.Item onClick={() => navigate(
          `/trainer/details`,{
            state:{id:row.original.trainer_id}
          },
          { replace: true }
        )}>Details</Menu.Item>
      </>
    ),
  });

  return <Paper shadow="sm" p="lg" withBorder>
                <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px', width: '100%' }}>

  <MantineReactTable
    table={table}
    striped // Enables the striped rows
    highlightOnHover
    horizontalSpacing="md"
    verticalSpacing="sm"
    fontSize="sm"
    withColumnBorders
    borderRadius="md"
    withGlobalFilter
    height={400}
    rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
    enablePagination={true} // Enables pagination
  />
  </div>
</Paper>
};

export default Example;
